export type UnqEscrow = {
  version: "0.1.0";
  name: "unq_escrow";
  instructions: [
    {
      name: "initializeEscrow";
      accounts: [
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        },
        {
          name: "maker";
          isMut: false;
          isSigner: true;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "makerOfferedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "offeredTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "wantedTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "escrowedOfferedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "escrowedWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "offeredAmount";
          type: "u64";
        },
        {
          name: "wantedAmount";
          type: "u64";
        },
        {
          name: "dedicatedTaker";
          type: {
            option: "publicKey";
          };
        }
      ];
    },
    {
      name: "accept";
      accounts: [
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        },
        {
          name: "escrowedOfferedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "taker";
          isMut: true;
          isSigner: true;
        },
        {
          name: "treasury";
          isMut: true;
          isSigner: false;
        },
        {
          name: "takerOfferedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "takerWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "wantedTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "escrowedWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "cancel";
      accounts: [
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "maker";
          isMut: false;
          isSigner: true;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "makerOfferedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "escrowedWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "escrowedOfferedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "proposalPda";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "initializeWithdrawal";
      accounts: [
        {
          name: "realm";
          isMut: false;
          isSigner: false;
        },
        {
          name: "treasuryData";
          isMut: false;
          isSigner: false;
        },
        {
          name: "treasury";
          isMut: true;
          isSigner: true;
        },
        {
          name: "treasuryToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "withdrawal";
          isMut: true;
          isSigner: false;
        },
        {
          name: "withdrawalData";
          isMut: true;
          isSigner: false;
        },
        {
          name: "withdrawalMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "proposalMetadata";
          isMut: false;
          isSigner: false;
        },
        {
          name: "clubData";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "withdrawalAmount";
          type: "u64";
        }
      ];
    },
    {
      name: "withdraw";
      accounts: [
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "memberData";
          isMut: false;
          isSigner: false;
        },
        {
          name: "memberTokens";
          isMut: true;
          isSigner: false;
        },
        {
          name: "financialRecord";
          isMut: false;
          isSigner: false;
        },
        {
          name: "withdrawal";
          isMut: true;
          isSigner: false;
        },
        {
          name: "withdrawalData";
          isMut: true;
          isSigner: false;
        },
        {
          name: "withdrawalRecord";
          isMut: true;
          isSigner: false;
        },
        {
          name: "treasuryData";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "distribute";
      accounts: [
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        },
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenLedger";
          isMut: true;
          isSigner: false;
        },
        {
          name: "ledgerEntry";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "profit";
          isMut: true;
          isSigner: false;
        },
        {
          name: "profitToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "escrowedWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "makerWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "executeMeBuyNow";
      accounts: [
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "sellersWallet";
          isMut: true;
          isSigner: false;
        },
        {
          name: "magicEdenExerchina";
          isMut: false;
          isSigner: false;
        },
        {
          name: "magicEdenEscrowedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "magicEdenEscrowedTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "magicEdenEscrowedTokenMetadata";
          isMut: false;
          isSigner: false;
        },
        {
          name: "magicEdenState1";
          isMut: true;
          isSigner: false;
        },
        {
          name: "escrowedWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "autExer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "e8cExer";
          isMut: false;
          isSigner: false;
        },
        {
          name: "expoitExer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "magicEdenState2";
          isMut: true;
          isSigner: false;
        },
        {
          name: "magicEdenState3";
          isMut: true;
          isSigner: false;
        },
        {
          name: "onebwExer";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "associatedTokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        },
        {
          name: "candyMachine";
          isMut: true;
          isSigner: false;
        },
        {
          name: "royaltyHolder";
          isMut: true;
          isSigner: false;
        },
        {
          name: "magicEden";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "dataBuffer";
          type: {
            vec: "bytes";
          };
        }
      ];
    },
    {
      name: "initalizeMeBuyOffer";
      accounts: [
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "wantedTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "escrowedWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "data";
          type: {
            vec: "bytes";
          };
        }
      ];
    },
    {
      name: "initalizeMeSellOffer";
      accounts: [
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        },
        {
          name: "treasury";
          isMut: true;
          isSigner: true;
        },
        {
          name: "vault";
          isMut: false;
          isSigner: true;
        },
        {
          name: "offeredTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "wantedTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "makerWantedToken";
          isMut: false;
          isSigner: false;
        },
        {
          name: "escrowedWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "data";
          type: "bytes";
        }
      ];
    },
    {
      name: "transferFunds";
      accounts: [
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        },
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "treasuryToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "destination";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "transferAmount";
          type: "u64";
        }
      ];
    },
    {
      name: "addLedgerEntry";
      accounts: [
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        },
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenLedger";
          isMut: true;
          isSigner: false;
        },
        {
          name: "ledgerEntry";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "reallocSpace";
      accounts: [
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "changeOfferStatus";
      accounts: [
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "signer";
          isMut: true;
          isSigner: true;
        }
      ];
      args: [
        {
          name: "status";
          type: {
            defined: "OfferStatus";
          };
        }
      ];
    },
    {
      name: "updateWithdrawalData";
      accounts: [
        {
          name: "withdrawalData";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "updateRoleConfig";
      accounts: [
        {
          name: "realm";
          isMut: false;
          isSigner: false;
        },
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "updateRoleData";
          type: {
            vec: {
              defined: "UpdateRoleData";
            };
          };
        }
      ];
    },
    {
      name: "initializeSolseaEscrow";
      accounts: [
        {
          name: "offer";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "proposal";
          isMut: false;
          isSigner: false;
        },
        {
          name: "offeredTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "wantedTokenMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "escrowWantedToken";
          isMut: true;
          isSigner: false;
        },
        {
          name: "makerWantedTokens";
          isMut: false;
          isSigner: false;
        },
        {
          name: "maker";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "tokenProgram";
          isMut: false;
          isSigner: false;
        },
        {
          name: "rent";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [
        {
          name: "wantedAmount";
          type: "u64";
        },
        {
          name: "offeredAmount";
          type: "u64";
        },
        {
          name: "sellerFeeBps";
          type: "u16";
        }
      ];
    },
    {
      name: "closeProgramAccount";
      accounts: [
        {
          name: "accountInfo";
          isMut: true;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    },
    {
      name: "updateLedger";
      accounts: [
        {
          name: "tokenLedger";
          isMut: true;
          isSigner: false;
        },
        {
          name: "tokenLedgerMint";
          isMut: false;
          isSigner: false;
        },
        {
          name: "treasury";
          isMut: false;
          isSigner: false;
        },
        {
          name: "payer";
          isMut: true;
          isSigner: true;
        },
        {
          name: "systemProgram";
          isMut: false;
          isSigner: false;
        }
      ];
      args: [];
    }
  ];
  accounts: [
    {
      name: "tokenLedger";
      type: {
        kind: "struct";
        fields: [
          {
            name: "ledgerEntriesCount";
            type: "u32";
          },
          {
            name: "denominatedCurrency";
            type: "publicKey";
          },
          {
            name: "tokenLedgerMint";
            type: "publicKey";
          },
          {
            name: "treasury";
            type: "publicKey";
          }
        ];
      };
    },
    {
      name: "ledgerEntry";
      type: {
        kind: "struct";
        fields: [
          {
            name: "buy";
            type: {
              defined: "Order";
            };
          },
          {
            name: "sell";
            type: {
              defined: "Order";
            };
          },
          {
            name: "profit";
            type: "u64";
          },
          {
            name: "profitType";
            type: {
              defined: "ProfitType";
            };
          },
          {
            name: "tokenLedger";
            type: "publicKey";
          }
        ];
      };
    },
    {
      name: "offer";
      type: {
        kind: "struct";
        fields: [
          {
            name: "maker";
            type: "publicKey";
          },
          {
            name: "treasury";
            type: "publicKey";
          },
          {
            name: "offeredAmount";
            type: "u64";
          },
          {
            name: "offeredTokenMint";
            type: "publicKey";
          },
          {
            name: "wantedAmount";
            type: "u64";
          },
          {
            name: "wantedTokenMint";
            type: "publicKey";
          },
          {
            name: "tokenLedgerMint";
            type: "publicKey";
          },
          {
            name: "makerWantedToken";
            type: "publicKey";
          },
          {
            name: "escrowedWantedToken";
            type: "publicKey";
          },
          {
            name: "status";
            type: {
              defined: "OfferStatus";
            };
          },
          {
            name: "offerType";
            type: {
              defined: "OfferType";
            };
          },
          {
            name: "dedicatedTaker";
            type: {
              option: "publicKey";
            };
          },
          {
            name: "proposal";
            type: "publicKey";
          },
          {
            name: "sellerFeeBps";
            type: "u16";
          }
        ];
      };
    },
    {
      name: "withdrawal";
      type: {
        kind: "struct";
        fields: [];
      };
    },
    {
      name: "withdrawalData";
      type: {
        kind: "struct";
        fields: [
          {
            name: "realm";
            type: "publicKey";
          },
          {
            name: "clubData";
            type: "publicKey";
          },
          {
            name: "treasury";
            type: "publicKey";
          },
          {
            name: "proposal";
            type: "publicKey";
          },
          {
            name: "fundraiseNumber";
            type: "u32";
          },
          {
            name: "withdrawalAmount";
            type: "u64";
          },
          {
            name: "amountWithdrawn";
            type: "u64";
          },
          {
            name: "totalFinancialPower";
            type: "u64";
          },
          {
            name: "withdrawalMint";
            type: "publicKey";
          },
          {
            name: "proposalCreatedAt";
            type: "i64";
          }
        ];
      };
    },
    {
      name: "withdrawalRecord";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authority";
            type: "publicKey";
          },
          {
            name: "hasWithdrawn";
            type: "bool";
          },
          {
            name: "withdrawnAmount";
            type: "u64";
          }
        ];
      };
    }
  ];
  types: [
    {
      name: "AllowedMemberData";
      type: {
        kind: "struct";
        fields: [
          {
            name: "clubData";
            type: "publicKey";
          },
          {
            name: "memberPubkey";
            type: "publicKey";
          },
          {
            name: "isMember";
            type: "bool";
          },
          {
            name: "status";
            type: "u8";
          },
          {
            name: "role";
            type: "string";
          },
          {
            name: "joinedAt";
            type: "i64";
          },
          {
            name: "joinedAtSlot";
            type: "u64";
          }
        ];
      };
    },
    {
      name: "UpdateRoleData";
      type: {
        kind: "struct";
        fields: [
          {
            name: "role";
            type: "string";
          },
          {
            name: "currentWeight";
            type: "u64";
          },
          {
            name: "updateWeight";
            type: "u64";
          }
        ];
      };
    },
    {
      name: "FinancialRecord";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authority";
            type: "publicKey";
          },
          {
            name: "treasury";
            type: "publicKey";
          },
          {
            name: "sellOffersCount";
            type: "u32";
          },
          {
            name: "listedFinancialRights";
            type: "u64";
          },
          {
            name: "depositRecords";
            type: {
              vec: {
                defined: "DepositRecord";
              };
            };
          }
        ];
      };
    },
    {
      name: "DepositRecord";
      type: {
        kind: "struct";
        fields: [
          {
            name: "accumulatedAmount";
            type: "u64";
          },
          {
            name: "fundraiseIndex";
            type: "u32";
          },
          {
            name: "depositedAt";
            type: "i64";
          },
          {
            name: "currentFundraiseDeposit";
            type: "u64";
          },
          {
            name: "tradedRight";
            type: {
              option: {
                vec: {
                  defined: "TradedRight";
                };
              };
            };
          }
        ];
      };
    },
    {
      name: "TradedRight";
      type: {
        kind: "struct";
        fields: [
          {
            name: "amount";
            type: "u64";
          },
          {
            name: "timestamp";
            type: "i64";
          },
          {
            name: "tradeType";
            type: {
              defined: "TradedRightType";
            };
          }
        ];
      };
    },
    {
      name: "Order";
      type: {
        kind: "struct";
        fields: [
          {
            name: "amount";
            type: "u64";
          },
          {
            name: "mint";
            type: "publicKey";
          },
          {
            name: "slot";
            type: "u64";
          },
          {
            name: "createdAt";
            type: "i64";
          }
        ];
      };
    },
    {
      name: "ProposalMetadata";
      type: {
        kind: "struct";
        fields: [
          {
            name: "name";
            type: "string";
          },
          {
            name: "options";
            type: {
              vec: "string";
            };
          },
          {
            name: "authority";
            type: "publicKey";
          },
          {
            name: "discussionLink";
            type: "string";
          },
          {
            name: "treasury";
            type: "publicKey";
          },
          {
            name: "currentFundraiseIndex";
            type: "u32";
          },
          {
            name: "totalFinancialPower";
            type: "u64";
          },
          {
            name: "proposal";
            type: "publicKey";
          },
          {
            name: "proposalIndex";
            type: "u32";
          },
          {
            name: "realm";
            type: "publicKey";
          },
          {
            name: "clubData";
            type: "publicKey";
          },
          {
            name: "governance";
            type: "publicKey";
          },
          {
            name: "isCreated";
            type: "bool";
          },
          {
            name: "description";
            type: "string";
          },
          {
            name: "authorityRole";
            type: "string";
          },
          {
            name: "dataPda";
            type: {
              option: "publicKey";
            };
          },
          {
            name: "proposalType";
            type: {
              defined: "ProposalType";
            };
          },
          {
            name: "proposalStatus";
            type: {
              defined: "ProposalStatus";
            };
          },
          {
            name: "createdAt";
            type: "i64";
          }
        ];
      };
    },
    {
      name: "TreasuryData";
      type: {
        kind: "struct";
        fields: [
          {
            name: "fundraiseCount";
            type: "u32";
          },
          {
            name: "treasury";
            type: "publicKey";
          },
          {
            name: "hasActiveFundraise";
            type: "bool";
          },
          {
            name: "governance";
            type: "publicKey";
          },
          {
            name: "maxVoterWeight";
            type: "u64";
          },
          {
            name: "totalFinancialPower";
            type: "u64";
          },
          {
            name: "denominatedCurrency";
            type: {
              option: "publicKey";
            };
          },
          {
            name: "financialTokenAccount";
            type: {
              option: "publicKey";
            };
          },
          {
            name: "sellPermission";
            type: {
              array: [
                {
                  defined: "SellPermission";
                },
                10
              ];
            };
          },
          {
            name: "withdrawalGovernance";
            type: {
              option: "publicKey";
            };
          },
          {
            name: "financialRecordCount";
            type: "u32";
          },
          {
            name: "treasuryIndex";
            type: "u32";
          },
          {
            name: "financialOffersCount";
            type: "u32";
          },
          {
            name: "transferGovernance";
            type: {
              option: "publicKey";
            };
          },
          {
            name: "changeClubConfigGovernance";
            type: {
              option: "publicKey";
            };
          },
          {
            name: "hasActiveUpdateGovernanceConfig";
            type: "bool";
          },
          {
            name: "clubData";
            type: "publicKey";
          },
          {
            name: "reservedRights";
            type: {
              option: {
                defined: "ReservedRights";
              };
            };
          }
        ];
      };
    },
    {
      name: "ReservedRights";
      type: {
        kind: "struct";
        fields: [
          {
            name: "totalReservedRights";
            type: "u64";
          },
          {
            name: "totalReservedPercentage";
            type: "u32";
          },
          {
            name: "individualRights";
            type: {
              vec: {
                defined: "IndividualRight";
              };
            };
          }
        ];
      };
    },
    {
      name: "IndividualRight";
      type: {
        kind: "struct";
        fields: [
          {
            name: "memberPubkey";
            type: "publicKey";
          },
          {
            name: "rightPercentage";
            type: "u32";
          },
          {
            name: "amountOfRights";
            type: "u64";
          }
        ];
      };
    },
    {
      name: "TradedRightType";
      type: {
        kind: "enum";
        variants: [
          {
            name: "Buy";
          },
          {
            name: "Sell";
          }
        ];
      };
    },
    {
      name: "ProfitType";
      type: {
        kind: "enum";
        variants: [
          {
            name: "Gain";
          },
          {
            name: "Loss";
          }
        ];
      };
    },
    {
      name: "OfferStatus";
      type: {
        kind: "enum";
        variants: [
          {
            name: "Initialised";
          },
          {
            name: "Accepted";
          },
          {
            name: "Canceled";
          },
          {
            name: "PendingBuyNowExecutionOnMagicEden";
          },
          {
            name: "ExecutedBuyNowOnMagicEden";
          },
          {
            name: "CanceledOnMagic";
          },
          {
            name: "PendingSellExecutionOnMagicEden";
          },
          {
            name: "ExecutedSellOnMagicEden";
          },
          {
            name: "FundsTransfered";
          },
          {
            name: "ListedOnSolsea";
          },
          {
            name: "ExecutedBuyNowOnSolsea";
          },
          {
            name: "CanceledOnSolsea";
          }
        ];
      };
    },
    {
      name: "OfferType";
      type: {
        kind: "enum";
        variants: [
          {
            name: "Buy";
          },
          {
            name: "Sell";
          }
        ];
      };
    },
    {
      name: "ProposalAction";
      type: {
        kind: "enum";
        variants: [
          {
            name: "BuyNFT";
          },
          {
            name: "SellNFT";
          }
        ];
      };
    },
    {
      name: "ProposalType";
      type: {
        kind: "enum";
        variants: [
          {
            name: "BuyP2P";
          },
          {
            name: "SellP2P";
          },
          {
            name: "BuyNowMagicEden";
          },
          {
            name: "SellMagicEden";
          },
          {
            name: "TransferFunds";
          },
          {
            name: "Discussion";
          },
          {
            name: "Withdrawal";
          },
          {
            name: "SellSolsea";
          },
          {
            name: "BuySolsea";
          }
        ];
      };
    },
    {
      name: "ProposalStatus";
      type: {
        kind: "enum";
        variants: [
          {
            name: "Pending";
          },
          {
            name: "CreatedBuyP2P";
          },
          {
            name: "CreatedSellP2P";
          },
          {
            name: "ExecutedBuyP2P";
          },
          {
            name: "ExecutedSellP2P";
          },
          {
            name: "CreatedBuyNowMagicEden";
          },
          {
            name: "ExecutedBuyNowMagicEden";
          },
          {
            name: "FinishedBuyNowMagicEden";
          },
          {
            name: "CreatedSellMagicEden";
          },
          {
            name: "ExecutedSellMagicEden";
          },
          {
            name: "FinishedSellMagicEden";
          },
          {
            name: "CreatedTransferFunds";
          },
          {
            name: "ExecutedTransferFunds";
          },
          {
            name: "CreatedDiscussion";
          },
          {
            name: "CreatedWithdrawal";
          },
          {
            name: "ExecutedWithdrawal";
          },
          {
            name: "CanceledByOwner";
          },
          {
            name: "ExecutedSolseaBuy";
          },
          {
            name: "ExecutedSolseaSell";
          }
        ];
      };
    }
  ];
  errors: [
    {
      code: 6000;
      name: "MintError";
      msg: "Wrong mint found!";
    },
    {
      code: 6001;
      name: "DedicationError";
      msg: "You are not authorized to accept this escrow!";
    },
    {
      code: 6002;
      name: "NotEnoughTokenToOffer";
      msg: "Less amount of Token than required to initialize!";
    },
    {
      code: 6003;
      name: "NoAuthorityOverOfferAcc";
      msg: "Wrong authority over the offered Tokens account!";
    },
    {
      code: 6004;
      name: "NoAuthorityOverWantedAcc";
      msg: "Wrong authority over the wanted Tokens account!";
    },
    {
      code: 6005;
      name: "NotEnoughTokenToExchange";
      msg: "Less amount of Token than required to accept escrow!";
    },
    {
      code: 6006;
      name: "OfferedTokensTransferToEscrow";
      msg: "Offered Tokens transfer to escrow failed!";
    },
    {
      code: 6007;
      name: "WantedTokensTransferToEscrow";
      msg: "Wanted Tokens transfer failed!";
    },
    {
      code: 6008;
      name: "FromPdaToTakerErr";
      msg: "Failed to transfer Tokens from PDA account to Taker's token account!";
    },
    {
      code: 6009;
      name: "AccountClosingErr";
      msg: "Failed to close PDA account!";
    },
    {
      code: 6010;
      name: "FromPdaToMakerErr";
      msg: "Failed to transfer Tokens from PDA account to Makers's token account!";
    },
    {
      code: 6011;
      name: "OfferClosureErr";
      msg: "Failed to close offer account!";
    },
    {
      code: 6012;
      name: "WrongMakerWantedTokenAccount";
      msg: "Wrong maker wanted token account";
    },
    {
      code: 6013;
      name: "WrongPayer";
      msg: "Signer is not the treasury that initialized the Escrow!";
    },
    {
      code: 6014;
      name: "AlreadyAcceptedOrCanceled";
      msg: "The offer was already accepted or was canceled!";
    },
    {
      code: 6015;
      name: "WrongFundraiseConfig";
      msg: "The offer was already accepted or was canceled!";
    },
    {
      code: 6016;
      name: "WrongSplGovProgram";
      msg: "Wrong spl gov id!";
    },
    {
      code: 6017;
      name: "WrongProposalAddress";
      msg: "Wrong proposal address!";
    },
    {
      code: 6018;
      name: "FundraiseStillInProgress";
      msg: "Fundraise still in progress!";
    },
    {
      code: 6019;
      name: "InvalidDepositRecord";
      msg: "The deposit record provided is not valid for this withdrawal";
    },
    {
      code: 6020;
      name: "NotAMemberOfTheClub";
      msg: "The deposit record provided is not valid for this withdrawal";
    },
    {
      code: 6021;
      name: "WrongLedgerEntry";
      msg: "Wrong ledger entry address";
    },
    {
      code: 6022;
      name: "LedgerEntryAlreadyInitialized";
      msg: "Ledger entry already initialized";
    },
    {
      code: 6023;
      name: "BuySellMintMissmatch";
      msg: "Buy-Sell mint missmatch";
    },
    {
      code: 6024;
      name: "WrongTreasury";
      msg: "This is not the treasury that initialized the escrow";
    },
    {
      code: 6025;
      name: "WrongDepositRecord";
      msg: "Invalid DepositRecord provided";
    },
    {
      code: 6026;
      name: "WrongDepositRecordOwner";
      msg: "Payer is not the owner of the DepositRecord";
    },
    {
      code: 6027;
      name: "TokenMetadataDoesNotMatch";
      msg: "Token metadata does not match";
    },
    {
      code: 6028;
      name: "InvalidAccountOwner";
      msg: "Invalid account owner";
    },
    {
      code: 6029;
      name: "InvalidTokenMetadataAccount";
      msg: "Invalid token metadata account";
    },
    {
      code: 6030;
      name: "SpaceForSellerFeeAlreadyAllocated";
      msg: "Space for seller fee already reallocated";
    },
    {
      code: 6031;
      name: "InvalidStatusToCancelOffer";
      msg: "Invalid status to cancel offer";
    },
    {
      code: 6032;
      name: "InvalidStatusToAddLedgerEntry";
      msg: "Invalid status of offer to add LedgerEntry";
    },
    {
      code: 6033;
      name: "WrongWithdrawalAccount";
      msg: "Withdrawal account with wrong address passed";
    },
    {
      code: 6034;
      name: "WrongOwnerOfMemberTokens";
      msg: "Wrong owner of member tokens";
    },
    {
      code: 6035;
      name: "NoFinancialRights";
      msg: "No available financial rights";
    }
  ];
};

export const IDL: UnqEscrow = {
  version: "0.1.0",
  name: "unq_escrow",
  instructions: [
    {
      name: "initializeEscrow",
      accounts: [
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
        {
          name: "maker",
          isMut: false,
          isSigner: true,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "makerOfferedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "offeredTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "wantedTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "escrowedOfferedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "escrowedWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "offeredAmount",
          type: "u64",
        },
        {
          name: "wantedAmount",
          type: "u64",
        },
        {
          name: "dedicatedTaker",
          type: {
            option: "publicKey",
          },
        },
      ],
    },
    {
      name: "accept",
      accounts: [
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
        {
          name: "escrowedOfferedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "taker",
          isMut: true,
          isSigner: true,
        },
        {
          name: "treasury",
          isMut: true,
          isSigner: false,
        },
        {
          name: "takerOfferedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "takerWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "wantedTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "escrowedWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "cancel",
      accounts: [
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "maker",
          isMut: false,
          isSigner: true,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "makerOfferedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "escrowedWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "escrowedOfferedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "proposalPda",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "initializeWithdrawal",
      accounts: [
        {
          name: "realm",
          isMut: false,
          isSigner: false,
        },
        {
          name: "treasuryData",
          isMut: false,
          isSigner: false,
        },
        {
          name: "treasury",
          isMut: true,
          isSigner: true,
        },
        {
          name: "treasuryToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "withdrawal",
          isMut: true,
          isSigner: false,
        },
        {
          name: "withdrawalData",
          isMut: true,
          isSigner: false,
        },
        {
          name: "withdrawalMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "proposalMetadata",
          isMut: false,
          isSigner: false,
        },
        {
          name: "clubData",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "withdrawalAmount",
          type: "u64",
        },
      ],
    },
    {
      name: "withdraw",
      accounts: [
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "memberData",
          isMut: false,
          isSigner: false,
        },
        {
          name: "memberTokens",
          isMut: true,
          isSigner: false,
        },
        {
          name: "financialRecord",
          isMut: false,
          isSigner: false,
        },
        {
          name: "withdrawal",
          isMut: true,
          isSigner: false,
        },
        {
          name: "withdrawalData",
          isMut: true,
          isSigner: false,
        },
        {
          name: "withdrawalRecord",
          isMut: true,
          isSigner: false,
        },
        {
          name: "treasuryData",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "distribute",
      accounts: [
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenLedger",
          isMut: true,
          isSigner: false,
        },
        {
          name: "ledgerEntry",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "profit",
          isMut: true,
          isSigner: false,
        },
        {
          name: "profitToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "escrowedWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "makerWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "executeMeBuyNow",
      accounts: [
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "sellersWallet",
          isMut: true,
          isSigner: false,
        },
        {
          name: "magicEdenExerchina",
          isMut: false,
          isSigner: false,
        },
        {
          name: "magicEdenEscrowedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "magicEdenEscrowedTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "magicEdenEscrowedTokenMetadata",
          isMut: false,
          isSigner: false,
        },
        {
          name: "magicEdenState1",
          isMut: true,
          isSigner: false,
        },
        {
          name: "escrowedWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "autExer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "e8cExer",
          isMut: false,
          isSigner: false,
        },
        {
          name: "expoitExer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "magicEdenState2",
          isMut: true,
          isSigner: false,
        },
        {
          name: "magicEdenState3",
          isMut: true,
          isSigner: false,
        },
        {
          name: "onebwExer",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "associatedTokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
        {
          name: "candyMachine",
          isMut: true,
          isSigner: false,
        },
        {
          name: "royaltyHolder",
          isMut: true,
          isSigner: false,
        },
        {
          name: "magicEden",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "dataBuffer",
          type: {
            vec: "bytes",
          },
        },
      ],
    },
    {
      name: "initalizeMeBuyOffer",
      accounts: [
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "wantedTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "escrowedWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "data",
          type: {
            vec: "bytes",
          },
        },
      ],
    },
    {
      name: "initalizeMeSellOffer",
      accounts: [
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
        {
          name: "treasury",
          isMut: true,
          isSigner: true,
        },
        {
          name: "vault",
          isMut: false,
          isSigner: true,
        },
        {
          name: "offeredTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "wantedTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "makerWantedToken",
          isMut: false,
          isSigner: false,
        },
        {
          name: "escrowedWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "data",
          type: "bytes",
        },
      ],
    },
    {
      name: "transferFunds",
      accounts: [
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "treasuryToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "transferAmount",
          type: "u64",
        },
      ],
    },
    {
      name: "addLedgerEntry",
      accounts: [
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenLedger",
          isMut: true,
          isSigner: false,
        },
        {
          name: "ledgerEntry",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "reallocSpace",
      accounts: [
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "changeOfferStatus",
      accounts: [
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "signer",
          isMut: true,
          isSigner: true,
        },
      ],
      args: [
        {
          name: "status",
          type: {
            defined: "OfferStatus",
          },
        },
      ],
    },
    {
      name: "updateWithdrawalData",
      accounts: [
        {
          name: "withdrawalData",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "updateRoleConfig",
      accounts: [
        {
          name: "realm",
          isMut: false,
          isSigner: false,
        },
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "updateRoleData",
          type: {
            vec: {
              defined: "UpdateRoleData",
            },
          },
        },
      ],
    },
    {
      name: "initializeSolseaEscrow",
      accounts: [
        {
          name: "offer",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "proposal",
          isMut: false,
          isSigner: false,
        },
        {
          name: "offeredTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "wantedTokenMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "escrowWantedToken",
          isMut: true,
          isSigner: false,
        },
        {
          name: "makerWantedTokens",
          isMut: false,
          isSigner: false,
        },
        {
          name: "maker",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: "wantedAmount",
          type: "u64",
        },
        {
          name: "offeredAmount",
          type: "u64",
        },
        {
          name: "sellerFeeBps",
          type: "u16",
        },
      ],
    },
    {
      name: "closeProgramAccount",
      accounts: [
        {
          name: "accountInfo",
          isMut: true,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: "updateLedger",
      accounts: [
        {
          name: "tokenLedger",
          isMut: true,
          isSigner: false,
        },
        {
          name: "tokenLedgerMint",
          isMut: false,
          isSigner: false,
        },
        {
          name: "treasury",
          isMut: false,
          isSigner: false,
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
        },
      ],
      args: [],
    },
  ],
  accounts: [
    {
      name: "tokenLedger",
      type: {
        kind: "struct",
        fields: [
          {
            name: "ledgerEntriesCount",
            type: "u32",
          },
          {
            name: "denominatedCurrency",
            type: "publicKey",
          },
          {
            name: "tokenLedgerMint",
            type: "publicKey",
          },
          {
            name: "treasury",
            type: "publicKey",
          },
        ],
      },
    },
    {
      name: "ledgerEntry",
      type: {
        kind: "struct",
        fields: [
          {
            name: "buy",
            type: {
              defined: "Order",
            },
          },
          {
            name: "sell",
            type: {
              defined: "Order",
            },
          },
          {
            name: "profit",
            type: "u64",
          },
          {
            name: "profitType",
            type: {
              defined: "ProfitType",
            },
          },
          {
            name: "tokenLedger",
            type: "publicKey",
          },
        ],
      },
    },
    {
      name: "offer",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maker",
            type: "publicKey",
          },
          {
            name: "treasury",
            type: "publicKey",
          },
          {
            name: "offeredAmount",
            type: "u64",
          },
          {
            name: "offeredTokenMint",
            type: "publicKey",
          },
          {
            name: "wantedAmount",
            type: "u64",
          },
          {
            name: "wantedTokenMint",
            type: "publicKey",
          },
          {
            name: "tokenLedgerMint",
            type: "publicKey",
          },
          {
            name: "makerWantedToken",
            type: "publicKey",
          },
          {
            name: "escrowedWantedToken",
            type: "publicKey",
          },
          {
            name: "status",
            type: {
              defined: "OfferStatus",
            },
          },
          {
            name: "offerType",
            type: {
              defined: "OfferType",
            },
          },
          {
            name: "dedicatedTaker",
            type: {
              option: "publicKey",
            },
          },
          {
            name: "proposal",
            type: "publicKey",
          },
          {
            name: "sellerFeeBps",
            type: "u16",
          },
        ],
      },
    },
    {
      name: "withdrawal",
      type: {
        kind: "struct",
        fields: [],
      },
    },
    {
      name: "withdrawalData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "realm",
            type: "publicKey",
          },
          {
            name: "clubData",
            type: "publicKey",
          },
          {
            name: "treasury",
            type: "publicKey",
          },
          {
            name: "proposal",
            type: "publicKey",
          },
          {
            name: "fundraiseNumber",
            type: "u32",
          },
          {
            name: "withdrawalAmount",
            type: "u64",
          },
          {
            name: "amountWithdrawn",
            type: "u64",
          },
          {
            name: "totalFinancialPower",
            type: "u64",
          },
          {
            name: "withdrawalMint",
            type: "publicKey",
          },
          {
            name: "proposalCreatedAt",
            type: "i64",
          },
        ],
      },
    },
    {
      name: "withdrawalRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey",
          },
          {
            name: "hasWithdrawn",
            type: "bool",
          },
          {
            name: "withdrawnAmount",
            type: "u64",
          },
        ],
      },
    },
  ],
  types: [
    {
      name: "AllowedMemberData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "clubData",
            type: "publicKey",
          },
          {
            name: "memberPubkey",
            type: "publicKey",
          },
          {
            name: "isMember",
            type: "bool",
          },
          {
            name: "status",
            type: "u8",
          },
          {
            name: "role",
            type: "string",
          },
          {
            name: "joinedAt",
            type: "i64",
          },
          {
            name: "joinedAtSlot",
            type: "u64",
          },
        ],
      },
    },
    {
      name: "UpdateRoleData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "role",
            type: "string",
          },
          {
            name: "currentWeight",
            type: "u64",
          },
          {
            name: "updateWeight",
            type: "u64",
          },
        ],
      },
    },
    {
      name: "FinancialRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey",
          },
          {
            name: "treasury",
            type: "publicKey",
          },
          {
            name: "sellOffersCount",
            type: "u32",
          },
          {
            name: "listedFinancialRights",
            type: "u64",
          },
          {
            name: "depositRecords",
            type: {
              vec: {
                defined: "DepositRecord",
              },
            },
          },
        ],
      },
    },
    {
      name: "DepositRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "accumulatedAmount",
            type: "u64",
          },
          {
            name: "fundraiseIndex",
            type: "u32",
          },
          {
            name: "depositedAt",
            type: "i64",
          },
          {
            name: "currentFundraiseDeposit",
            type: "u64",
          },
          {
            name: "tradedRight",
            type: {
              option: {
                vec: {
                  defined: "TradedRight",
                },
              },
            },
          },
        ],
      },
    },
    {
      name: "TradedRight",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64",
          },
          {
            name: "timestamp",
            type: "i64",
          },
          {
            name: "tradeType",
            type: {
              defined: "TradedRightType",
            },
          },
        ],
      },
    },
    {
      name: "Order",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64",
          },
          {
            name: "mint",
            type: "publicKey",
          },
          {
            name: "slot",
            type: "u64",
          },
          {
            name: "createdAt",
            type: "i64",
          },
        ],
      },
    },
    {
      name: "ProposalMetadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string",
          },
          {
            name: "options",
            type: {
              vec: "string",
            },
          },
          {
            name: "authority",
            type: "publicKey",
          },
          {
            name: "discussionLink",
            type: "string",
          },
          {
            name: "treasury",
            type: "publicKey",
          },
          {
            name: "currentFundraiseIndex",
            type: "u32",
          },
          {
            name: "totalFinancialPower",
            type: "u64",
          },
          {
            name: "proposal",
            type: "publicKey",
          },
          {
            name: "proposalIndex",
            type: "u32",
          },
          {
            name: "realm",
            type: "publicKey",
          },
          {
            name: "clubData",
            type: "publicKey",
          },
          {
            name: "governance",
            type: "publicKey",
          },
          {
            name: "isCreated",
            type: "bool",
          },
          {
            name: "description",
            type: "string",
          },
          {
            name: "authorityRole",
            type: "string",
          },
          {
            name: "dataPda",
            type: {
              option: "publicKey",
            },
          },
          {
            name: "proposalType",
            type: {
              defined: "ProposalType",
            },
          },
          {
            name: "proposalStatus",
            type: {
              defined: "ProposalStatus",
            },
          },
          {
            name: "createdAt",
            type: "i64",
          },
        ],
      },
    },
    {
      name: "TreasuryData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "fundraiseCount",
            type: "u32",
          },
          {
            name: "treasury",
            type: "publicKey",
          },
          {
            name: "hasActiveFundraise",
            type: "bool",
          },
          {
            name: "governance",
            type: "publicKey",
          },
          {
            name: "maxVoterWeight",
            type: "u64",
          },
          {
            name: "totalFinancialPower",
            type: "u64",
          },
          {
            name: "denominatedCurrency",
            type: {
              option: "publicKey",
            },
          },
          {
            name: "financialTokenAccount",
            type: {
              option: "publicKey",
            },
          },
          {
            name: "sellPermission",
            type: {
              array: [
                {
                  defined: "SellPermission",
                },
                10,
              ],
            },
          },
          {
            name: "withdrawalGovernance",
            type: {
              option: "publicKey",
            },
          },
          {
            name: "financialRecordCount",
            type: "u32",
          },
          {
            name: "treasuryIndex",
            type: "u32",
          },
          {
            name: "financialOffersCount",
            type: "u32",
          },
          {
            name: "transferGovernance",
            type: {
              option: "publicKey",
            },
          },
          {
            name: "changeClubConfigGovernance",
            type: {
              option: "publicKey",
            },
          },
          {
            name: "hasActiveUpdateGovernanceConfig",
            type: "bool",
          },
          {
            name: "clubData",
            type: "publicKey",
          },
          {
            name: "reservedRights",
            type: {
              option: {
                defined: "ReservedRights",
              },
            },
          },
        ],
      },
    },
    {
      name: "ReservedRights",
      type: {
        kind: "struct",
        fields: [
          {
            name: "totalReservedRights",
            type: "u64",
          },
          {
            name: "totalReservedPercentage",
            type: "u32",
          },
          {
            name: "individualRights",
            type: {
              vec: {
                defined: "IndividualRight",
              },
            },
          },
        ],
      },
    },
    {
      name: "IndividualRight",
      type: {
        kind: "struct",
        fields: [
          {
            name: "memberPubkey",
            type: "publicKey",
          },
          {
            name: "rightPercentage",
            type: "u32",
          },
          {
            name: "amountOfRights",
            type: "u64",
          },
        ],
      },
    },
    {
      name: "TradedRightType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Buy",
          },
          {
            name: "Sell",
          },
        ],
      },
    },
    {
      name: "ProfitType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Gain",
          },
          {
            name: "Loss",
          },
        ],
      },
    },
    {
      name: "OfferStatus",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Initialised",
          },
          {
            name: "Accepted",
          },
          {
            name: "Canceled",
          },
          {
            name: "PendingBuyNowExecutionOnMagicEden",
          },
          {
            name: "ExecutedBuyNowOnMagicEden",
          },
          {
            name: "CanceledOnMagic",
          },
          {
            name: "PendingSellExecutionOnMagicEden",
          },
          {
            name: "ExecutedSellOnMagicEden",
          },
          {
            name: "FundsTransfered",
          },
          {
            name: "ListedOnSolsea",
          },
          {
            name: "ExecutedBuyNowOnSolsea",
          },
          {
            name: "CanceledOnSolsea",
          },
        ],
      },
    },
    {
      name: "OfferType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Buy",
          },
          {
            name: "Sell",
          },
        ],
      },
    },
    {
      name: "ProposalAction",
      type: {
        kind: "enum",
        variants: [
          {
            name: "BuyNFT",
          },
          {
            name: "SellNFT",
          },
        ],
      },
    },
    {
      name: "ProposalType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "BuyP2P",
          },
          {
            name: "SellP2P",
          },
          {
            name: "BuyNowMagicEden",
          },
          {
            name: "SellMagicEden",
          },
          {
            name: "TransferFunds",
          },
          {
            name: "Discussion",
          },
          {
            name: "Withdrawal",
          },
          {
            name: "SellSolsea",
          },
          {
            name: "BuySolsea",
          },
        ],
      },
    },
    {
      name: "ProposalStatus",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Pending",
          },
          {
            name: "CreatedBuyP2P",
          },
          {
            name: "CreatedSellP2P",
          },
          {
            name: "ExecutedBuyP2P",
          },
          {
            name: "ExecutedSellP2P",
          },
          {
            name: "CreatedBuyNowMagicEden",
          },
          {
            name: "ExecutedBuyNowMagicEden",
          },
          {
            name: "FinishedBuyNowMagicEden",
          },
          {
            name: "CreatedSellMagicEden",
          },
          {
            name: "ExecutedSellMagicEden",
          },
          {
            name: "FinishedSellMagicEden",
          },
          {
            name: "CreatedTransferFunds",
          },
          {
            name: "ExecutedTransferFunds",
          },
          {
            name: "CreatedDiscussion",
          },
          {
            name: "CreatedWithdrawal",
          },
          {
            name: "ExecutedWithdrawal",
          },
          {
            name: "CanceledByOwner",
          },
          {
            name: "ExecutedSolseaBuy",
          },
          {
            name: "ExecutedSolseaSell",
          },
        ],
      },
    },
  ],
  errors: [
    {
      code: 6000,
      name: "MintError",
      msg: "Wrong mint found!",
    },
    {
      code: 6001,
      name: "DedicationError",
      msg: "You are not authorized to accept this escrow!",
    },
    {
      code: 6002,
      name: "NotEnoughTokenToOffer",
      msg: "Less amount of Token than required to initialize!",
    },
    {
      code: 6003,
      name: "NoAuthorityOverOfferAcc",
      msg: "Wrong authority over the offered Tokens account!",
    },
    {
      code: 6004,
      name: "NoAuthorityOverWantedAcc",
      msg: "Wrong authority over the wanted Tokens account!",
    },
    {
      code: 6005,
      name: "NotEnoughTokenToExchange",
      msg: "Less amount of Token than required to accept escrow!",
    },
    {
      code: 6006,
      name: "OfferedTokensTransferToEscrow",
      msg: "Offered Tokens transfer to escrow failed!",
    },
    {
      code: 6007,
      name: "WantedTokensTransferToEscrow",
      msg: "Wanted Tokens transfer failed!",
    },
    {
      code: 6008,
      name: "FromPdaToTakerErr",
      msg: "Failed to transfer Tokens from PDA account to Taker's token account!",
    },
    {
      code: 6009,
      name: "AccountClosingErr",
      msg: "Failed to close PDA account!",
    },
    {
      code: 6010,
      name: "FromPdaToMakerErr",
      msg: "Failed to transfer Tokens from PDA account to Makers's token account!",
    },
    {
      code: 6011,
      name: "OfferClosureErr",
      msg: "Failed to close offer account!",
    },
    {
      code: 6012,
      name: "WrongMakerWantedTokenAccount",
      msg: "Wrong maker wanted token account",
    },
    {
      code: 6013,
      name: "WrongPayer",
      msg: "Signer is not the treasury that initialized the Escrow!",
    },
    {
      code: 6014,
      name: "AlreadyAcceptedOrCanceled",
      msg: "The offer was already accepted or was canceled!",
    },
    {
      code: 6015,
      name: "WrongFundraiseConfig",
      msg: "The offer was already accepted or was canceled!",
    },
    {
      code: 6016,
      name: "WrongSplGovProgram",
      msg: "Wrong spl gov id!",
    },
    {
      code: 6017,
      name: "WrongProposalAddress",
      msg: "Wrong proposal address!",
    },
    {
      code: 6018,
      name: "FundraiseStillInProgress",
      msg: "Fundraise still in progress!",
    },
    {
      code: 6019,
      name: "InvalidDepositRecord",
      msg: "The deposit record provided is not valid for this withdrawal",
    },
    {
      code: 6020,
      name: "NotAMemberOfTheClub",
      msg: "The deposit record provided is not valid for this withdrawal",
    },
    {
      code: 6021,
      name: "WrongLedgerEntry",
      msg: "Wrong ledger entry address",
    },
    {
      code: 6022,
      name: "LedgerEntryAlreadyInitialized",
      msg: "Ledger entry already initialized",
    },
    {
      code: 6023,
      name: "BuySellMintMissmatch",
      msg: "Buy-Sell mint missmatch",
    },
    {
      code: 6024,
      name: "WrongTreasury",
      msg: "This is not the treasury that initialized the escrow",
    },
    {
      code: 6025,
      name: "WrongDepositRecord",
      msg: "Invalid DepositRecord provided",
    },
    {
      code: 6026,
      name: "WrongDepositRecordOwner",
      msg: "Payer is not the owner of the DepositRecord",
    },
    {
      code: 6027,
      name: "TokenMetadataDoesNotMatch",
      msg: "Token metadata does not match",
    },
    {
      code: 6028,
      name: "InvalidAccountOwner",
      msg: "Invalid account owner",
    },
    {
      code: 6029,
      name: "InvalidTokenMetadataAccount",
      msg: "Invalid token metadata account",
    },
    {
      code: 6030,
      name: "SpaceForSellerFeeAlreadyAllocated",
      msg: "Space for seller fee already reallocated",
    },
    {
      code: 6031,
      name: "InvalidStatusToCancelOffer",
      msg: "Invalid status to cancel offer",
    },
    {
      code: 6032,
      name: "InvalidStatusToAddLedgerEntry",
      msg: "Invalid status of offer to add LedgerEntry",
    },
    {
      code: 6033,
      name: "WrongWithdrawalAccount",
      msg: "Withdrawal account with wrong address passed",
    },
    {
      code: 6034,
      name: "WrongOwnerOfMemberTokens",
      msg: "Wrong owner of member tokens",
    },
    {
      code: 6035,
      name: "NoFinancialRights",
      msg: "No available financial rights",
    },
  ],
};
